import { ColumnLinks, Link, PromoCard } from '../types';

export const subtitle = 'Learn about our unique generosity programs';

export const givingBackLinks: ColumnLinks = {
  title: 'GIVING BACK',
  links: [
    {
      text: 'Generosity',
      href: 'https://www.thrivent.com/generosity',
    },
    {
      text: 'Thrivent Charitable',
      href: 'https://thriventcharitable.thrivent.com/',
    },
  ],
};

export const membershipLinks: ColumnLinks = {
  title: 'MEMBERSHIP',
  links: [
    {
      text: 'Member Benefits',
      href: 'https://www.thrivent.com/about-us/membership',
    },
  ],
};

export const primaryLink: Link = {
  text: `Generosity`,
  href: 'https://www.thrivent.com/generosity',
};

export const promoCard: PromoCard = {
  title: 'Client Story',
  description: `Doc's passion for giving back grew with Thrivent, allowing him to impact young people in his community.`,
  callToActionText: 'Read Doc’s story',
  callToActionHref: 'https://www.thrivent.com/client-stories',
};
